export const getEvidenceName = (evidence: { properties: Record<string, unknown> }): string => {
  if (typeof evidence.properties.name === "string") {
    return evidence.properties.name;
  }

  const label = evidence.properties.label as Record<string, string>;
  return label?.ja ?? "-";
};
